import { render, staticRenderFns } from "./ReportDownload.vue?vue&type=template&id=bcb9d924&scoped=true"
import script from "./ReportDownload.vue?vue&type=script&lang=js"
export * from "./ReportDownload.vue?vue&type=script&lang=js"
import style0 from "./ReportDownload.vue?vue&type=style&index=0&id=bcb9d924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb9d924",
  null
  
)

export default component.exports